const tableHeader = [
  {
    title: 'transaction_list.header.status',
  },
  {
    title: 'transaction_list.header.created',
  },
  {
    title: 'transaction_list.header.txid',
  },
  {
    title: 'transaction_list.header.tid',
  },
  {
    title: 'transaction_list.header.payer',
  },
  {
    title: 'transaction_list.header.amount',
  },
  {
    title: 'transaction_list.header.ref',
  },
  {
    title: 'transaction_list.header.qr_type',
  },
];

export default tableHeader;
